import React from 'react';
import Proptypes from 'prop-types';
import Info from '@material-ui/icons/Info';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '../../lib/styles';

import Tooltip from '../Tooltip';

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.text.secondary,
    fill: 'currentColor',
    width: 18,
    height: 18,
    marginRight: 8,
  },
}));

function InfoAdornment({ infoText }) {
  if (!infoText) return null;
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      <Tooltip content={infoText}>
        <Info className={classes.icon} />
      </Tooltip>
    </InputAdornment>
  );
}

InfoAdornment.propTypes = {
  infoText: Proptypes.string,
};

InfoAdornment.defaultProps = {
  infoText: '',
};

export default InfoAdornment;
